// extracted by mini-css-extract-plugin
export default {"toast":"Toast_toast__CkuAE","fade":"Toast_fade__Uf3Jr"};